import AUTH from "./auth";
import MODULE from "./module";
import { f7 } from "framework7-vue";
import CONST from "./constant";

var API = {
	protocol: "https",
	domain: "www.bj-sup.kr",
	//domain: "www.bj-sup.kr",
	//domain: "bj-dev.o2brain.co.kr",
	//domain: "bj-alpha.o2brain.co.kr",
	baseUrl() {
		return this.protocol + "://" + this.domain + "/pwa/api";
	},

	iniPayUrl() {
		return this.protocol + "://" + this.domain + "/dweb";
	},
  
	iniKMCISUrl() {
		return this.protocol + "://" + this.domain + "/dweb";
	},

	loginUrl() {
		return this.baseUrl() + "/guest/login.json";
	},
	tokenLoginUrl() {
		return this.baseUrl() + "/guest/tokenLogin.json";
	},
	tokenLogoutUrl() {
		return this.baseUrl() + "/user/logout.json";
	},
	getUserInfo(){
		return this.baseUrl() + "/user/getUserInfo.json";
	},
	checkPassword(){
		return this.baseUrl() + "/user/checkPassword.json";
	},
	getCertInfo() {
		return this.baseUrl() + "/guest/getCertInfo.json";
	},
	getCertAuthResult() {
		return this.iniKMCISUrl() + "/all_guest/kmcert/cert/cert/certResult.page";
	},

	// myroom
	getMyCourseListUrl() {
		return this.baseUrl() + "/student/getMyCourseList.json";
	},
	getMyHomeWorkListUrl(){
		return this.baseUrl() + "/student/getMyHomeWorkList.json";
	},
	getCourseDashBoardUrl() {
		return this.baseUrl() + "/student/getCourseDashBoard.json";
	},
	getMyPointListUrl() { 
		return this.baseUrl() + "/points/getMyPointList.json";
	},

	getCourseBunitListUrl() {
		return this.baseUrl() + "/study/getCourseBunitList.json";
	},

	// clinic
	getMunitSunitClinicListUrl() {
		return this.baseUrl() + "/study/getMunitSunitClinicList.json";
	},
	getClinicSelfStudyInfoUrl() {
		return this.baseUrl() + "/study/getClinicSelfStudyInfo.json";
	},
	saveClinicSelfStudyUrl() {
		return this.baseUrl() + "/study/saveClinicSelfStudy.json";
	},

	// pat
	getMunitSunitPatListUrl() {
		return this.baseUrl() + "/study/getMunitSunitPatList.json";
	},
	getPatConquerSelfStudyInfoUrl() {
		return this.baseUrl() + "/study/getPatConquerSelfStudyInfo.json";
	},
	savePatConquerSelfStudyUrl() {
		return this.baseUrl() + "/study/savePatConquerSelfStudy.json";
	},

	// examset
	getExamSetSelfStudyInfoUrl() {
		return this.baseUrl() + "/study/getExamSetSelfStudyInfo.json";
	},
	getExamSetHomeworkInfoUrl() {
		return this.baseUrl() + "/study/getExamSetHomeworkInfo.json";
	},
	saveExamSetSelfStudyUrl() {
		return this.baseUrl() + "/study/saveExamSetSelfStudy.json";
	},
	saveExamSetHomeworkUrl() {
		return this.baseUrl() + "/study/saveExamSetHomework.json";
	},
	getExamSetApplyResultUrl() {
		return this.baseUrl() + "/study/getExamSetApplyResult.json";
	},

	getMatchPaperApplyInfoUrl() {
		return this.baseUrl() + "/study/getMatchPaperApplyInfo.json";
	},
	saveMatchPaperStudyUrl() {
		return this.baseUrl() + "/study/saveMatchPaperStudy.json";
	},
	saveMatchPaperSelfStudyUrl() {
		return this.baseUrl() + "/study/saveMatchPaperSelfStudy.json";
	},
	getMatchPaperApplyResultUrl() {
		return this.baseUrl() + "/study/getMatchPaperApplyResult.json";
	},
	getMatchPaperStudyListUrl() {
		return this.baseUrl() + "/study/getMatchPaperStudyList.json";
	},

	getMatchBookApplyInfoUrl() {
		return this.baseUrl() + "/study/getMatchBookApplyInfo.json";
	},
	saveMatchBookSelfStudyUrl() {
		return this.baseUrl() + "/study/saveMatchBookSelfStudy.json";
	},
	saveMatchBookHomeWorkUrl() {
		return this.baseUrl() + "/study/saveMatchBookHomeWork.json";
	},
	getMatchBookApplyResultUrl() {
		return this.baseUrl() + "/study/getMatchBookApplyResult.json";
	},	
	getMyMatchBookList() {
		return this.baseUrl() + "/study/getMyMatchBookList.json";
	},
	addMyMatchBook() {
		return this.baseUrl() + "/study/addMyMatchBook.json";
	},
	removeMyMatchBook() {
		return this.baseUrl() + "/study/removeMyMatchBook.json";
	},
	getMyMatchBookResultList() {
		return this.baseUrl() + "/study/getMyMatchBookResultList.json";
	}, 

	linkExamContentsUrl() {
		return this.baseUrl() + "/study/getLinkExamContents.json";		
	},
	lectureContentsUrl() {
		return this.baseUrl() + "/study/getLectureContents.json";
	},
	saveLinkExamSelfStudyUrl() {
		return this.baseUrl() + "/study/saveLinkExamSelfStudy.json";
	},

	getCodeSelfStudyListUrl() {
		return this.baseUrl() + "/study/getCodeSelfStudyList.json";
	},
	getCodeSelfApplyListUrl() {
		return this.baseUrl() + "/study/getCodeSelfApplyList.json";
	},

	getContentsReportListUrl() {
		return this.baseUrl() + "/customer/getMyReportList.json";
	},
	getContentsReportUrl() {
		return this.baseUrl() + "/customer/getContentsReport.json";
	},
	addContentsReportUrl() {
		return this.baseUrl() + "/customer/addContentsReport.json";
	},
	addReportCommentUrl() {
		return this.baseUrl() + "/customer/addReportComment.json";
	},

	getDiagTestInfoUrl() {
		return this.baseUrl() + "/diag/getDiagTestInfo.json";
	},


	checkId(){
		return this.baseUrl() +"/guest/checkId.json";
	},
	checkChildCode() {
		return this.baseUrl() +"/guest/checkChildCode.json";
	},
	getCompanyKey(){
		return this.baseUrl() + "/guest/getCompanyKey.json";
	},
	addUser(){
		return this.baseUrl() + "/guest/addUser.json";
	},
	addParentUser() {
		return this.baseUrl() + "/guest/addParentUser.json";
	},
	editUser(){
		return this.baseUrl() + "/user/editUser.json";		
	},
	findUserId(){
		return this.baseUrl() + "/guest/findUserId.json";
	},
	getNoticeList(){
		return this.baseUrl() +"/board/noticeList.json";
	},

	//parent
	getMyChildListUrl() {
		return this.baseUrl() + "/parent/getMyChildList.json";
	},

	addChildUrl() {
		return this.baseUrl() + "/parent/addChild.json";
	},

	deleteChildUrl() {
		return this.baseUrl() + "/parent/deleteChild.json";
	},

	getPaymentListUrl() {
		return this.baseUrl() + "/parent/getPaymentList.json";
	},

	getPaymentAddrUrl() {
		return this.baseUrl() + "/parent/getPaymentAddrUrl.json";
	},

	setPaymentInfoUrl() {
		return this.baseUrl() + "/parent/setPaymentInfo.json";
	},

	getPaymentOnlineListUrl() {
		return this.baseUrl() + "/parent/getPaymentOnlineList.json";
	},

	addPaymentBasketUrl() {
		return this.baseUrl() + "/parent/addPaymentBasket.json";
	},

	deletePaymentBasketUrl() {
		return this.baseUrl() + "/parent/deletePaymentBasket.json";
	},

	getPaymentResultListUrl() {
		return this.baseUrl() + "/parent/getPaymentResultList.json";
	},

	getOrderInfoUrl() {
		return this.baseUrl() + "/parent/getOrderInfo.json";
	},

	getIniPayMobileCertResultUrl() {
		return this.iniPayUrl() + "/all_guest/payment/inipay/inipay/mobileCertResult.page";
	},

	getIniPayWebCertResultUrl() {
		return this.iniPayUrl() + "/all_guest/payment/inipay/inipay/webCertResult.page";
	},
	iniPayWebCloseUrl() {
		return this.iniPayUrl() + "/all_guest/payment/inipay/inipay/webCloseResult.page";
	},
	iniPayWebPopUpUrl() {
		return this.iniPayUrl() + "/all_guest/payment/inipay/inipay/webIniPayPopUp.page";
	},

	getIniPayNotiResultUrl() {
		return this.iniPayUrl() + "/all_guest/payment/inipay/inipay/notiResult.page";
	},
	
	getBasketCountUrl() {
		return this.baseUrl() + "/parent/getBasketCount.json";
	},

	//planner
	getStudyPlanDayUrl() {
		return this.baseUrl() + "/planner/getStudyPlanDay.json";
	},

	getStudyReviewInfoUrl() {
		return this.baseUrl() + "/planner/getStudyReviewInfo.json";
	},

	getStudyReviewApplyInfoUrl() {
		return this.baseUrl() + "/planner/getStudyReviewApplyInfo.json";
	},

	getStudyReviewApplyResultUrl() {
		return this.baseUrl() + "/planner/getStudyReviewApplyResult.json";
	},

	saveStudyReviewApplyResultUrl() {
		return this.baseUrl() + "/planner/saveStudyReviewApplyResult.json";
	},

	getStudyUnitInfoUrl() {
		return this.baseUrl() + "/planner/getStudyUnitInfo.json";
	},

	saveStudyUnitLectureUrl() {
		return this.baseUrl() + "/planner/saveStudyUnitLecture.json";
	},

	getStudyUnitApplyInfoUrl() {
		return this.baseUrl() + "/planner/getStudyUnitApplyInfo.json";
	},

	getStudyUnitApplyResultUrl() {
		return this.baseUrl() + "/planner/getStudyUnitApplyResult.json";
	},   

	saveStudyUnitApplyResultUrl() {
		return this.baseUrl() + "/planner/saveStudyUnitApplyResult.json";
	},

	getStudyFirstClinicInfoUrl() {
		return this.baseUrl() + "/planner/getStudyFirstClinicInfo.json";
	},

	getStudySecondClinicInfoUrl() {
		return this.baseUrl() + "/planner/getStudySecondClinicInfo.json";
	},

	getStudyClinicApplyInfoUrl() {
		return this.baseUrl() + "/planner/getStudyClinicApplyInfo.json";
	},

	getStudyClinicApplyResultUrl() {
		return this.baseUrl() + "/planner/getStudyClinicApplyResult.json";
	},

	saveStudyClinicApplyResultUrl() {
		return this.baseUrl() + "/planner/saveStudyClinicApplyResult.json";
	},

	setCompleteStudyTimesUrl() {
		return this.baseUrl() + "/planner/setCompleteStudyTimes.json";
	},

	getStudyPlanWeekUrl() {
		return this.baseUrl() + "/planner/getStudyPlanWeek.json";
	},

	getStudyPlanMonthUrl() {
		return this.baseUrl() + "/planner/getStudyPlanMonth.json";
	},

	manualTokenAjaxRequest: function (param) {
		var _this = this;

		return new Promise((resolve, reject) => {
			MODULE.LAST_REQUEST_TIME = moment();

			// param = {url:"", data:{}, type:""}

			var accessToken = AUTH.getAccessToken();
			if (MODULE.Util.isNotEmpty(accessToken) && param.accessToken == undefined) {
				param.accessToken = accessToken;
			}

			var ajaxObject = {};
			ajaxObject.url = param.url;
			ajaxObject.data = param.data || "";
			ajaxObject.method = param.method || "POST";
			ajaxObject.dataType = "json";
			ajaxObject.beforeSend = function (xhr) {
				//xhr.setRequestHeader("Accept", "application/json");
				//xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
			};
			ajaxObject.success = function (data, textStatus, responseObject) {
				var jsonText = responseObject.responseText;
				var jsonObject = jQuery.parseJSON(jsonText);
				var resultCode = jsonObject.code;
				var resultValue = jsonObject.value;

				if (resultCode == CONST.resultCode.OK) {
					resolve(resultValue);
				} else {
					reject(resultCode);
				}
			};
			ajaxObject.error = function (jqXHR, exception) {
				if (jqXHR.status === 0) {
					reject("NETWORK-ERROR");
					return;
				} else if (jqXHR.status == 404) {
					reject("404-ERROR");
					return;
				} else if (jqXHR.status == 500) {
					reject("500-ERROR");
					return;
				} else if (exception === "parsererror") {
					reject("PARSER-ERROR");
					return;
				} else if (exception === "timeout") {
					msg = "Time out error.";
					reject("TIMEOUT-ERROR");
					return;
				} else if (exception === "abort") {
					msg = "Ajax request aborted.";
					reject("ABORTED-ERROR");
					return;
				}

				reject("ERROR");
			};

			f7.request(ajaxObject);
		});
	},
	ajaxRequest: function (param) {
		var _this = this;

		f7.preloader.show();

		return _this.manualTokenAjaxRequest(param)
			.then(function (data) {
				f7.preloader.hide();

				return Promise.resolve(data);
			})
			.catch(function (code) {
				f7.preloader.hide();

				if (code == CONST.resultCode.TOKEN_EXPIRED || 
					code == CONST.resultCode.INVALID || 
					code == CONST.resultCode.TOKEN_MISMATCH) 
				{
					AUTH.removeUserInfo();
					AUTH.removeAccessToken();
					_this.removeAccessTokenHeader();
				}

				return Promise.reject(code);
			});
	},
	manualTokenJsonRequest: function (param) {
		var _this = this;

		return new Promise((resolve, reject) => {
			MODULE.LAST_REQUEST_TIME = moment();

			// param = {url:"", data:{}, type:""}

			var accessToken = AUTH.getAccessToken();
			if (MODULE.Util.isNotEmpty(accessToken) && param.accessToken == undefined) {
				param.accessToken = accessToken;
			}

			var ajaxObject = {};
			ajaxObject.url = param.url;
			ajaxObject.data = param.data || "";
			ajaxObject.method = param.method || "POST";
			ajaxObject.dataType = "json";
			ajaxObject.contentType = "application/json";
			ajaxObject.beforeSend = function (xhr) {
				xhr.setRequestHeader("Accept", "application/json");
			};
			ajaxObject.success = function (data, textStatus, responseObject) {
				var jsonText = responseObject.responseText;
				var jsonObject = jQuery.parseJSON(jsonText);
				var resultCode = jsonObject.code;
				var resultValue = jsonObject.value;

				if (resultCode == CONST.resultCode.OK) {
					resolve(resultValue);
				} else {
					reject(resultCode);
				}
			};
			ajaxObject.error = function (jqXHR, exception) {
				if (jqXHR.status === 0) {
					reject("NETWORK-ERROR");
					return;
				} else if (jqXHR.status == 404) {
					reject("404-ERROR");
					return;
				} else if (jqXHR.status == 500) {
					reject("500-ERROR");
					return;
				} else if (exception === "parsererror") {
					reject("PARSER-ERROR");
					return;
				} else if (exception === "timeout") {
					msg = "Time out error.";
					reject("TIMEOUT-ERROR");
					return;
				} else if (exception === "abort") {
					msg = "Ajax request aborted.";
					reject("ABORTED-ERROR");
					return;
				}

				reject("ERROR");
			};

			f7.request(ajaxObject);
		});
	},
	jsonRequest: function (param) {
		var _this = this;

		f7.preloader.show();

		return _this.manualTokenJsonRequest(param)
			.then(function (data) {
				f7.preloader.hide();

				return Promise.resolve(data);
			})
			.catch(function (code) {
				f7.preloader.hide();

				if (code == CONST.resultCode.TOKEN_EXPIRED) {
					AUTH.removeUserInfo();
					AUTH.removeAccessToken();
					_this.removeAccessTokenHeader();
				}

				return Promise.reject(code);
			});
	},
	setAccessTokenHeader: function (accessToken) {
		f7.request.setup({
			headers: {
				accessToken: accessToken
			}
		});
	},
	removeAccessTokenHeader: function () {
		f7.request.setup({});
	},
	tokenLogin: function () {
		const _this = this;

		return new Promise((resolve, reject) => {

			let accessToken = AUTH.getAccessToken();

			if (MODULE.Util.isEmpty(accessToken)) {
				return reject(CONST.resultCode.EMPTY);
			}

			var param = {
				accessToken: accessToken
			};

			_this.ajaxRequest({
				url: API.tokenLoginUrl(),
				data: param
			}).then(function (data) {			
					// 토큰 저장은 자동화 되있음.
					let userInfo = AUTH.createUserInfo(data);

					if (data.accessToken) {
						AUTH.setAccessToken(data.accessToken);
						_this.setAccessTokenHeader(data.accessToken);
					}
				
					return resolve(userInfo);
				}).catch(function (code) {
					return reject(code);
				});
		});
	},
	logout: function () {
		const _this = this;

		return new Promise((resolve, reject) => {

			let accessToken = AUTH.getAccessToken();

			if (MODULE.Util.isEmpty(accessToken)) {
				return reject(CONST.resultCode.EMPTY);
			}

			var param = {
				accessToken: accessToken
			};

			_this.ajaxRequest({
				url: API.tokenLogoutUrl(),
				data: param
			})
				.then(function (data) {
					// 토큰 저장은 자동화 되있음.
					AUTH.removeUserInfo();
					_this.removeAccessTokenHeader();

					return resolve(userInfo);
				})
				.catch(function (code) {
					return reject(code);
				});
		});
	}
};

export default API;
